import axios from 'axios';
import getBaseUserUrl from './baseUserUrl';
import { configureHttpHeaders } from './apiHelpers';


function getOrganizationsUrl(userId, { parentOrgId, parentHierarchyCode, merchantNumber }) {
  configureHttpHeaders(axios);
  const baseUrl = getBaseUserUrl();
  let queryString = '';
  if (parentOrgId) {
    queryString = `?organizationId=${parentOrgId}`;
  } else if (parentHierarchyCode) {
    //return 'http://localhost:5449/api/v1/users/organizations/merchant';
    queryString = `?hierarchyCode=${parentHierarchyCode}`;
  } else if (merchantNumber) {
    queryString = `?hierarchyCode=${merchantNumber}`;
  }
  return `${baseUrl}api/v1/disputeusersdata/user/users/${userId}/organizations${queryString}`;
}
  

export function getOrganizations(userId, criteria) {
  const url = getOrganizationsUrl(userId, criteria);
  return axios.get(url).then((resp) => {
    return resp.data.data.content;
  });
}

export function getMerchantCount(hierarchyCode, orgId) {
  configureHttpHeaders(axios);
  const baseUrl = getBaseUserUrl();
  const queryString = orgId ? `organization=${orgId}` : `hierarchyCode=${hierarchyCode}`;
  const url = `${baseUrl}api/v1/disputeusersdata/user/users/merchantcount?${queryString}`;
  //const url = `http://localhost:5449/api/v1/users/organizations/merchantCount`;
  return axios.get(url).then((resp) => {
    return resp.data.data;
  });
}

export default getOrganizations;
